import { useMemo } from "react"

import type { LatLonRecord } from "types/geolocation.types"

import { useLastLocationsQuery } from "features/api"
import useDevices from "helpers/hooks/useDevices"
import { formatDeviceLatLonData } from "helpers/utils/map"

/**
 * Fetches and formats the latest location for a device.
 * `hasLocationData` is true when there is a renderable marker for the map.
 */
export const useDeviceLocationData = (deviceId: number | string) => {
  const { currentData: currentLocationData } = useLastLocationsQuery(
    { params: { less_id: Number(deviceId) } },
    { skip: !deviceId },
  )

  const { devsWRelsByIdWStates } = useDevices()

  const locationData = useMemo(
    () =>
      currentLocationData &&
      formatDeviceLatLonData(currentLocationData as LatLonRecord[], devsWRelsByIdWStates),
    [currentLocationData, devsWRelsByIdWStates],
  )

  const hasLocationData = Boolean(locationData && locationData.length > 0)

  return { locationData, hasLocationData }
}
